module.exports = __webpack_public_path__ + "static/sequence-diagram-9acd89ea20e5d570d8e96ffb696678f9.png";